import { FC, useEffect } from 'react';

import { usePageTitle } from '@app/hooks/usePageTitle';
import useActions from '@app/store/hooks/useActions';
import { TWalletType } from '@entities/wallets';
import { WalletsWidget } from '@widgets/wallets/monitoring';

interface IProps {
  type: TWalletType;
  showChildren?: boolean;
}

const titles = {
  deposit: 'Deposit wallets',
  withdraw: 'Withdrawal wallets',
  settlement: 'Settlement wallets',
};

const WalletsMonitoringPage: FC<IProps> = ({ type, showChildren }) => {
  const title = titles[type];
  const { setWalletType } = useActions();

  usePageTitle(title);

  useEffect(() => {
    setWalletType(type);
  }, [type, setWalletType]);

  return <WalletsWidget type={type} showChildren={showChildren} />;
};

export default WalletsMonitoringPage;
